import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class FragmentNavigationService {
  private readonly router = inject(Router);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  navigateToFragment(fragment: string): void {
    if (!fragment || !isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.isLandingRoute()) {
      if (!this.scrollToFragment(fragment)) {
        this.retryScroll(fragment);
      }
      return;
    }

    void this.router.navigate(['/'], { fragment }).then(ok => {
      if (ok) {
        this.retryScroll(fragment);
      }
    });
  }

  private isLandingRoute(): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    return path === '' || path === '/';
  }

  private scrollToFragment(fragment: string): boolean {
    const el = this.document.getElementById(fragment);
    if (!el) {
      return false;
    }
    el.scrollIntoView({ behavior: 'smooth' });
    return true;
  }

  private retryScroll(fragment: string, attempt = 0): void {
    if (this.scrollToFragment(fragment) || attempt >= 40) {
      return;
    }
    setTimeout(() => this.retryScroll(fragment, attempt + 1), 50);
  }
}
